<template>
  <Catalogs
    title="Статусы проекта"
    create-text="Новый"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'ProjectStatusAdd'"
    :route-edit="'ProjectStatusEdit'"
    :route-view="'ProjectStatusView'"
    :route-path="'/project_statuses'"
    :can-edit="canEditProjectStatusCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "ProjectStatuses",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'project-status-id'
        },
        {
          key: 'name',
          label: "Название",
          sortable: true,
        },
        {
          key: 'active',
          label: "Активный",
          sortable: true,
        },
        {
          key: 'action',
          label: "Действия",
          class: 'project-status-action'
        },
      ],
    }
  },
  methods: {
    async fetchData(data) {
      return await this.getProjectStatuses(data);
    },
    canEditProjectStatusCatalogs() {
      return this.hasPermission([PERM.CATALOG_PROJECT_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.project-status-id {
  padding-left: 10px !important;
  width: 60px;
  text-align: center;
}

.project-status-action {
  width: 80px;
  padding-right: 10px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/ProjectStatuses/ProjectStatuses.vue